import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'

export default {
  props: {
    calledId: String,
  },

  components: {
    InstitutionInactive,
    DepartmentInactive,
  },

  async created() {
    this.env = process.env.VUE_APP_BASE_URL;

    window.scrollTo(0, 0);
    this.userLogged = JSON.parse(localStorage.getItem('user'));

    this.currentCalled.requesterCellPhone = this.userLogged.cellPhoneNumber;
    this.getInstitutions();

    this.institution = JSON.parse(localStorage.getItem('institution'));
    this.institutionId = this.institution.id;
    this.institutionInactive = this.institution.status == 1;

    // IMPORTANTE: pega departmentTypes aqui
    this.institutionDepartmentTypes = Array.isArray(this.institution?.departmentTypes)
      ? this.institution.departmentTypes
      : [];

    this.verifyOpenCalled();
    await this.getEquipments();

    // ✅ Regra padrão (CRIAÇÃO)
    // (vai dar Setor se só Eng. Clínica (0), senão Equipamento)
    this.applyCategoryRule(true);

    // Se veio equipment do localStorage, isso é intenção explícita -> força Equipamento
    const equipment = JSON.parse(localStorage.getItem('equipmentId'));
    if (equipment) {
      this.equipmentId = equipment.id;
      this.currentCalled.category = 0; // Equipamento
      localStorage.removeItem('equipmentId');
      this.querySelectionsEquipment(equipment.identification);
      this.querySelectionsEquipments(equipment.identification);
      this.currentCalled.request = equipment.request;
    }

    await this.getUnidades();

    // Se veio departmentId na rota, isso é intenção explícita -> força Setor
    const departmentId = this.$route.query.departmentId;
    if (departmentId) {
      this.currentCalled.category = 1; // Setor
      this.currentCalled.departmentId = parseInt(departmentId);
      this.currentCalled.subDepartmentId = parseInt(this.$route.query.subDepartmentId);
      this.currentCalled.unidadeId = parseInt(this.$route.query.unidadeId);
      this.unidadeId = parseInt(this.$route.query.unidadeId);
    }

    if (this.calledId) {
      await this.getCalled();
    } else {
      this.user = this.userLogged;
    }

    await this.getWorkshops();
    this.getActivitiesByWorkshop();
    this.getSelectedActivities();
    // getCostCenter() será chamado quando uma unidade for selecionada
  },

  mounted() {},

  data: () => ({
    institution: {},
    env: '',
    categoryKey: false,
    equipKey: false,
    searchEquipment: null,
    searchEquipmentPropertyCode: null,
    errorMessage: '',
    message: '',
    showSuccess: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    equipmentLoading: false,
    disapproveLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    disapprove: false,
    institutionInactive: false,
    departmentInactive: false,
    buttonDisabled: false,
    departmentName: null,
    serviceTime: null,
    resolutionTime: null,
    stepServiceOrder: null,
    stepServiceOrderDate: null,
    calledCreatedAt: null,
    calledStatus: null,
    institutionId: null,
    institutions: [],
    costCenters: [],
    unidadeId: null,
    unidades: [],
    equipmentId: null,
    equipments: [],
    equipmentsFiltered: [],
    equipmentSelected: {},
    userLogged: {},
    user: {},
    unidade: {},
    categories: [
      {
        text: 'Equipamento',
        value: 0,
      },
      {
        text: 'Setor',
        value: 1,
      },
    ],
    currentCalled: {
      category: 0,
      departmentId: null,
      unidadeId: null,
      subDepartmentId: null,
      costCenterId: null,
      calledImages: [],
      costCenterId: null,
      id: 0,
      requesterCellPhone: '',
      request: '',
      statusDescription: '',
      disapprovedJustification: '',
      workshopId: null,
      workshopActivities: [],
    },
    institutionRules: [(v) => !!v || 'Instituição é requerida'],
    unidadeRules: [(v) => !!v || 'Unidade é requerida'],
    requestRules: [
      (v) => !!v || 'Solicitação/Reclamação é requerida',
      (v) =>
        v.length <= 1000 ||
        'Solicitação/Reclamação deve ter no máximo 1000 caracteres',
    ],
    apiService: new ApiService(),
    departmentLoading: false,
    searchEquipmentSerial: '',
    departments: [],
    unidadeLoading: false,
    unidades: [],
    urgentTypes: [
      {
        text: 'Alta',
        value: 0,
      },
      {
        text: 'Média',
        value: 1,
      },
      {
        text: 'Baixa',
        value: 2,
      },
    ],
    equipCalledsQuantity: 0,
    equipCalledsModal: false,
    institutionDepartmentTypes: [],
    workshops: null,
    workshopsLoading: false,
    workshopsKey: false,
    activity: null,
    activities: null,
    selectedActivities: [],
  }),

  computed: {
    subDepartments() {
      const department = this.departments.find(
        (x) => x.id == this.currentCalled.departmentId
      )
      return department ? department.subDepartments : []
    },
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {

    applyCategoryRule(force = false) {
      // Só aplica automaticamente ao CRIAR (não na edição)
      if (this.calledId) return;

      // Se já tem categoria e não quer forçar, não mexe (ex.: usuário já escolheu)
      if (
        !force &&
        this.currentCalled.category !== null &&
        this.currentCalled.category !== undefined
      ) return;

      // departmentTypes:
      // 0 = Engenharia Clínica
      // 1 = Manutenção Predial
      const rawTypes = Array.isArray(this.institutionDepartmentTypes)
        ? this.institutionDepartmentTypes
        : Array.isArray(this.institution?.departmentTypes)
          ? this.institution.departmentTypes
          : [];

      // Normaliza (caso venha "0"/"1")
      const types = rawTypes
        .map((x) => Number(x))
        .filter((x) => !Number.isNaN(x));

      const hasEngClinica = types.includes(0);
      const hasManutPredial = types.includes(1);

      // Regras:
      // - só Eng. Clínica (apenas 0) => Equipamento (0)
      // - só Manut. Predial (apenas 1) => Setor (1)
      // - ambos (0 e 1) => Equipamento (0) padrão
      if (!hasEngClinica && hasManutPredial) {
        // Só Manutenção Predial
        this.currentCalled.category = 1; // Setor
      } else {
        // Só Eng. Clínica OU ambos
        this.currentCalled.category = 0; // Equipamento
      }
    },

    autocompleteFilter(item, queryText, itemText) {
      const textOne = item.identification.toLowerCase()
      const textTwo = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      )
    },

    getUrgencyClass(urgency) {
      switch (urgency) {
        case 0:
          return 'high'
        case 1:
          return 'median'
        case 2:
          return 'low'
        default:
          return ''
      }
    },

    removeImage(image) {
      const index = this.currentCalled.calledImages.findIndex(
        (x) => x.path == image.path
      )

      this.currentCalled.calledImages.splice(index, 1)
    },

    openPicker() {
      document.getElementById('file-input').click()
    },

    setImage(files) {
      files.forEach((image) => {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = () => {
          this.currentCalled.calledImages.push({
            name: image.name,
            path: reader.result,
            extension: image.type.split('/')[1],
          })
        }
      })
    },

    async verifyOpenCalled() {
      this.apiService
        .get(`called/pendent-rating/${this.institutionId}`)
        .then((response) => {
          this.userLogged.pendingCalleds = response.content
          if (
            this.userLogged.pendingCalleds &&
            this.userLogged.pendingCalleds.length > 3
          ) {
            this.$router.push('/calleds')
            this.$toast.error(
              'Você possui três ou mais chamados sem avaliação. Por favor, avalie-os antes de abrir um novo chamado.'
            )
          }
        })
    },
    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/list/unidade/${this.unidadeId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },
    async getCostCenters() {},

    async getCostCenter() {
      if (!this.unidadeId || this.unidadeId === 0) {
        this.costCenters = []
        return
      }

      await this.apiService
        .get(`costCenter/listByUnidade/${this.institutionId}/${this.unidadeId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/calleds')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true
      window.scrollTo(0, 0)

      setTimeout(() => {
        this.showSuccess = false
        this.closeDialog()
      }, 1000)
    },

    async newServiceOrder() {
      await this.submit()

      localStorage.removeItem('called')
      localStorage.setItem('called', JSON.stringify(this.currentCalled))
      this.$router.push('/newServiceOrder')
    },

    openServiceOrder() {
      const serviceOrder = this.currentCalled.serviceOrder
      this.$router.push(`/editServiceOrder/${serviceOrder.id}`)
    },

    async getCalled() {
      await this.apiService
        .get(`called/${this.institutionId}/${this.calledId}`)
        .then((response) => {
          this.currentCalled = response.content

          this.equipmentId = response.content.equipmentId
          this.institutionId = response.content.institutionId
          this.unidadeId = response.content.unidadeId
          this.calledCreatedAt = this.formatDate(response.content.createdAt)

          if (response.content.equipment) {
            this.querySelectionsEquipment(
              response.content.equipment.identification
            )
            this.departmentInactive =
              response.content.equipment.department.status == 1

            if (
              response.content.equipment.contract &&
              response.content.equipment.contract.eContractCoverages &&
              response.content.equipment.contract.eContractCoverages.length > 0
            ) {
              const hasPreventiveMaintenance =
                response.content.equipment.contract.eContractCoverages.includes(
                  3
                )

              if (hasPreventiveMaintenance) {
                this.$toast.info(
                  'Equipamento em contrato de manutenção corretiva'
                )
              }
            }
          }

          this.user = response.content.userRequester
          switch (response.content.calledStatus) {
            case 0:
              this.calledStatus = 'Chamado enviado'
              break
            case 1:
              this.calledStatus = 'Em andamento'
              break
            case 2:
              this.calledStatus = 'Fechado'
              break
            case 3:
              this.calledStatus = 'Reprovado'
              break
          }

          if (response.content.serviceOrder != null) {
            this.getLastStep(response.content.serviceOrder.services)
          }
          this.buttonDisabled =
            this.institution.userType > 2 &&
            this.institution.userType != 8 &&
            this.userLogged.id != this.user.id

          this.getEquipmentById()

          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/calleds')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      let url = 'unidade/list'

      if (this.institutionId) {
        url = `unidade/list/${this.institutionId}`
      }

      await this.apiService.get(url).then((response) => {
        this.unidades = response.content
        this.unidadeLoading = false
      })
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/general/${this.institutionId}`)
        .then((response) => {
          this.equipments = response.content

          if (!this.isEditing) {
            this.equipments = this.equipments.filter((x) => !x.alienated)
          }

          this.equipmentLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getEquipmentById() {
      if (this.equipmentId) {
        await this.apiService
          .get(`equipment/${this.institutionId}/${this.equipmentId}`)
          .then(async (response) => {
            this.equipmentSelected = response.content
            this.unidadeId = response.content.unidadeId
            await this.getDepartment()
            this.getTimes()
          })
      }
      return
    },

    async getDepartment() {
      await this.apiService
        .get(`department/${this.equipmentSelected.departmentId}`)
        .then((response) => {
          this.departmentName = response.content.name
        })
    },

    getTimes() {
      this.serviceTime = ''
      this.resolutionTime = ''
      if (this.currentCalled.category == 1) {
        if (this.currentCalled.calledLevelUrgent == 0) {
          this.serviceTime = this.unidade.serviceTimeSupplierHighCriticality
          this.resolutionTime =
            this.unidade.resolutionTimeSupplierHighCriticality
        } else if (this.currentCalled.calledLevelUrgent == 1) {
          this.serviceTime = this.unidade.serviceTimeSupplierMediumCriticality
          this.resolutionTime =
            this.unidade.resolutionTimeSupplierMediumCriticality
        } else {
          this.serviceTime = this.unidade.serviceTimeSupplierLowCriticality
          this.resolutionTime =
            this.unidade.resolutionTimeSupplierLowCriticality
        }
      } else {
        if (
          this.equipmentSelected.criticality >= 3 &&
          this.equipmentSelected.criticality < 12
        ) {
          this.serviceTime =
            this.equipmentSelected.unidade.serviceTimeEquipmentLowCriticality
          this.resolutionTime =
            this.equipmentSelected.unidade.resolutionTimeEquipmentLowCriticality
        } else if (
          this.equipmentSelected.criticality >= 12 &&
          this.equipmentSelected.criticality < 19
        ) {
          this.serviceTime =
            this.equipmentSelected.unidade.serviceTimeEquipmentMediumCriticality
          this.resolutionTime =
            this.equipmentSelected.unidade.resolutionTimeEquipmentMediumCriticality
        } else if (
          this.equipmentSelected.criticality >= 19 &&
          this.equipmentSelected.criticality < 28
        ) {
          this.serviceTime =
            this.equipmentSelected.unidade.serviceTimeEquipmentHighCriticality
          this.resolutionTime =
            this.equipmentSelected.unidade.resolutionTimeEquipmentHighCriticality
        } else {
          this.serviceTime = null
          this.resolutionTime = null
        }
      }
    },

    getLastStep(services) {
      const lastStep =
        services.find((s) => s.isMainStep === true) ||
        services[services.length - 1]

      if (lastStep) {
        switch (lastStep.statusStepServiceOrder) {
          case 0:
            this.stepServiceOrder = 'Manutenção terceirizada in loco'
            break
          case 1:
            this.stepServiceOrder = 'Manutenção terceirizada externa'
            break
          case 2:
            this.stepServiceOrder = 'Manutenção interna'
            break
          case 3:
            this.stepServiceOrder = 'Aguardando peça'
            break
          case 4:
            this.stepServiceOrder = 'Aguardando orçamento'
            break
          case 5:
            this.stepServiceOrder = 'Aguardando avaliação externa'
            break
          case 6:
            this.stepServiceOrder = 'Aguardando aprovação de orçamento'
            break
          case 7:
            this.stepServiceOrder = 'Aguardando liberação do setor'
            break

          default:
            return null
        }

        this.stepServiceOrderDate = this.formatDate(lastStep.dateTimeStartStep)
      }
    },

    checkIfEquipHasCalled() {
      if (this.$refs.firstForm.validate()) {
        this.apiService
          .get(`called/check-if-equip-has-called/${this.equipmentId}`)
          .then((response) => {
            this.equipCalledsQuantity = response.content.length
            this.equipCalledsModal = this.equipCalledsQuantity > 0

            if (!this.equipCalledsModal) this.submit()
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        const called = {
          Id: this.currentCalled.id,
          CalledImages: this.currentCalled.calledImages,
          InstitutionId: this.institutionId,
          UnidadeId: this.unidadeId,
          UserRequesterId: this.userLogged.id,
          RequesterCellPhone: this.currentCalled.requesterCellPhone,
          Request: this.currentCalled.request,
          EquipmentId: this.equipmentId,
          StatusDescription: this.currentCalled.statusDescription,
          DisapprovedJustification: this.currentCalled.disapprovedJustification,
          ServiceOrderId: this.currentCalled.serviceOrderId,
          CalledStatus: this.currentCalled.calledStatus,
          departmentId: this.currentCalled.departmentId,
          calledLevelUrgent: this.currentCalled.calledLevelUrgent,
          category: this.currentCalled.category,
          subDepartmentId: this.currentCalled.subDepartmentId,
          userUpdateUrgentId: this.userLogged.id,
          workshopId: this.currentCalled.workshopId,
          workshopActivities: this.currentCalled.workshopActivities,
          costCenterId: this.currentCalled.costCenterId,
        }

        let url = 'called/add'
        let message = this.$t('Chamado adicionado com sucesso!')
        if (this.isEditing) {
          url = 'called/edit'
          message = this.$t('Chamado atualizado com sucesso!')
        }

        await this.apiService
          .post(url, called)
          .then(() => {
            const user = JSON.parse(localStorage.getItem('user'))
            this.equipCalledsModal = false
            user.pendingCalleds = []
            localStorage.setItem('user', JSON.stringify(user))
            sessionStorage.clear()
            this.getSelectedActivities()
            this.$toast.success(message)
            if (url == 'called/add') {
              this.$router.push('/calleds')
            } else {
              this.getCalled()
            }
          })
          .catch((err) => {
            this.equipCalledsModal = false
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }

      this.loading = false
      this.changedData = false
    },

    async disapproveCalled() {
      this.disapproveLoading = true
      const called = {
        Id: this.currentCalled.id,
        DisapprovedJustification: this.currentCalled.disapprovedJustification,
        reprovedByUserId: this.userLogged.id,
      }

      await this.apiService
        .post('called/disapprove', called)
        .then((response) => {
          this.showSuccessAlert(response.content)
        })
      this.disapproveLoading = false
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    async querySelectionsEquipmentSerial(value) {
      this.equipmentLoading = true

      setTimeout(async () => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.serialNumber && e.serialNumber.indexOf(value) > -1
        })

        if (!this.isEditing)
          this.equipmentsFiltered = this.equipmentsFiltered.filter(
            (x) => !x.alienated
          )

        this.equipmentLoading = false
        if (this.equipmentId && this.equipments.length > 0) {
          this.equipmentSelected = this.equipments.find(
            (x) => x.id == this.equipmentId
          )
          this.unidadeId = this.equipmentSelected.unidadeId
          this.getEquipmentById()
        }
      }, 500)
    },

    async querySelectionsEquipment(value) {
      if (value) {
        this.equipmentLoading = true
        setTimeout(async () => {
          this.equipmentsFiltered = this.equipments.filter(
            (e) =>
              e.identification.includes(value) ||
              e.name.toLowerCase().includes(value.toLowerCase())
          )

          if (!this.isEditing)
            this.equipmentsFiltered = this.equipmentsFiltered.filter(
              (x) => !x.alienated
            )

          this.equipmentLoading = false
          if (this.equipmentId && this.equipments.length > 0) {
            this.equipmentSelected = this.equipments.find(
              (x) => x.id == this.equipmentId
            )
            this.unidadeId = this.equipmentSelected.unidadeId
            this.getEquipmentById()
          }
        }, 500)
      }
    },

    async querySelectionsEquipments(value) {
      this.equipmentLoading = true

      setTimeout(async () => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          if (e.propertyCode != null) {
            return e.propertyCode.indexOf(value) > -1
          }
        })

        if (!this.isEditing)
          this.equipmentsFiltered = this.equipmentsFiltered.filter(
            (x) => !x.alienated
          )

        this.equipmentLoading = false
        if (this.equipmentId && this.equipments.length > 0) {
          this.equipmentSelected = this.equipments.find(
            (x) => x.id == this.equipmentId
          )
          this.unidadeId = this.equipmentSelected.unidadeId
          this.getEquipmentById()
        }
      }, 500)
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    getUrgency(id) {
      switch (id) {
        case 0:
          return 'Alta'
        case 1:
          return 'Média'
        case 2:
          return 'Baixa'
      }
    },

    async getWorkshops() {
      this.workshopsLoading = true
      try {
        const response = await this.apiService.get(
          `workshop/${this.institutionId}`
        )
        this.workshops = response.content
        this.workshopsLoading = false
      } catch (error) {
        console.error('Erro ao buscar workshops:', error)
        this.workshopsLoading = false
      } finally {
        this.workshopsLoading = false
      }
    },

    getActivitiesByWorkshop() {
      if (this.currentCalled.workshopId) {
        const workshop = this.workshops.find(
          (x) => x.id === this.currentCalled.workshopId
        )
        if (workshop) {
          this.activities = workshop.activities
        }
      }
    },

    handleActivities(selectedActivityIds) {
      if (
        Array.isArray(selectedActivityIds) &&
        selectedActivityIds.length > 0
      ) {
        this.selectedActivities = [
          selectedActivityIds[selectedActivityIds.length - 1],
        ]
      } else {
        this.selectedActivities = []
      }

      this.currentCalled.workshopActivities = [
        {
          workshopActivityId: this.selectedActivities[0],
        },
      ]

      this.updateRequestWithActivities()
    },

    removeActivities(index) {
      this.selectedActivities.splice(index, 1)

      this.currentCalled.workshopActivities = this.selectedActivities.map(
        (selectedActivityId) => {
          return {
            workshopActivityId: selectedActivityId,
          }
        }
      )
      this.updateRequestWithActivities()
    },

    updateRequestWithActivities() {
      const requestText = this.getRequestTextWithoutActivities()

      if (Array.isArray(this.activities) && this.activities.length > 0) {
        const activitiesList = this.currentCalled.workshopActivities
          .map((item) => {
            const activity = this.activities.find(
              (act) => act.id === item.workshopActivityId
            )
            return activity ? activity.title : ''
          })
          .filter((title) => title)
          .join('\n')

        this.currentCalled.request = `${requestText}\nAtividades Selecionadas:\n${activitiesList}`
      }
    },

    getRequestTextWithoutActivities() {
      const splitText = this.currentCalled.request.split(
        'Atividades Selecionadas:'
      )
      return splitText[0].trim()
    },

    addActivitiesToRequest() {
      this.updateRequestWithActivities()
    },

    getSelectedActivities() {
      this.selectedActivities = this.currentCalled.workshopActivities.map(
        (activity) => activity.workshopActivityId
      )
    },
  },

  watch: {
    'currentCalled.workshopActivities': {
      deep: true,
      handler() {
        this.addActivitiesToRequest()
      },
    },

    unidadeId() {
      this.unidade = this.unidades.find((x) => x.id == this.unidadeId)
      this.getDepartments()
      if (this.unidadeId) {
        this.getCostCenter()
      } else {
        this.costCenters = []
      }
    },

    currentCalled: {
      deep: true,
      handler() {
        this.getTimes()
        if (this.currentCalled.calledStatus < 2) {
          this.changedData = true
        }
      },
    },

    searchEquipment(value) {
      this.querySelectionsEquipment(value)

      return value && value !== this.equipmentId
    },

    searchEquipmentSerial(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipmentSerial(value)
    },

    searchEquipmentPropertyCode(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipments(value)
    },

    'institution.departments': {
      deep: true,
      handler() {
        this.applyCategoryRule(false);
      }
    }
  },
}
